import React, { useEffect, useRef } from 'react'
import MakeConcert from '../components/MakeConcert'
import { generateMongoDBId } from '../whitaijiFrontendLibrary/lib/utils'
import { useStateContext } from '../context/StateContext'
import { isGodMode } from '../utils/permissions';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext'
import { AuthContext } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'
import T from '../components/Translation'
import BlueButton from '../components/BlueButton'
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv';



const MakeConcertPage = () => {
    const {hideTestButtons, language, concert, setConcert} = useStateContext()
      const {user} = useAuthContext(AuthContext)
      const navigate = useNavigate();

      const isGodM = isGodMode(user)


  const convaiContainerRef = useRef(null);

  useEffect(() => {
    
    // Check if script already exists
    const scriptId = 'elevenlabs-convai-script';
    let script = document.getElementById(scriptId);
    
    // Only create and add the script if it doesn't already exist
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://elevenlabs.io/convai-widget/index.js';
      script.async = true;
      script.type = 'text/javascript';
      
      // Add script to document
      document.body.appendChild(script);
    }
    
    // Function to create and append the custom element
    const createConvaiElement = () => {
      // Only create the element if the container exists and doesn't already have the element
      if (convaiContainerRef.current && !convaiContainerRef.current.querySelector('elevenlabs-convai')) {
        try {
          // Create the custom element
          const convaiElement = document.createElement('elevenlabs-convai');
          convaiElement.setAttribute('agent-id', 'ZUz5EJSYclLyRmYCXKgG');
          
          // Append to the container
          convaiContainerRef.current.appendChild(convaiElement);
        } catch (error) {
          process.env.NODE_ENV === "development" && console.error('Error creating elevenlabs-convai element:', error);
        }
      }
    };
    
    // If script is already loaded, create element immediately
    if (script.hasAttribute('data-loaded')) {
      createConvaiElement();
    } else {
      // Otherwise wait for script to load
      script.addEventListener('load', () => {
        script.setAttribute('data-loaded', 'true');
        createConvaiElement();
      });
    }
    
    // Cleanup function
    return () => {
      // Only remove elements from the container, not the script
      if (convaiContainerRef.current) {
        const convaiElement = convaiContainerRef.current.querySelector('elevenlabs-convai');
        if (convaiElement) {
          convaiContainerRef.current.removeChild(convaiElement);
        }
      }
    };
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div style={{padding: "20px"}}>
        <MakeConcert/>
        <VisDiv rules={[isGodM, false]}>
          <div ref={convaiContainerRef} style={{marginTop: "20px"}}></div>
        </VisDiv>
    </div>
  )
}

export default MakeConcertPage
